<div class="filter-background" *ngIf="filtersOpened" (click)="showChangesNotifier()"></div>
<div class="changes-notify" [@openClose]="filtersOpened && notifyShown ? 'open' : 'closed'">
  <span>{{'CONTACTS_LIST.CHANGES_NOTIFIER' | translate}}
    <b>{{(isEditingFiltersOpened() ? 'DONE' : 'CONTACTS_LIST.APPLY_FILTERS') | translate}}</b>
  <i class="material-icons">
    arrow_forward
  </i>
  </span>
  <a href="javascript:void(0)" (click)="closeFilters()"><i class="datatable-icon-close"></i></a>
</div>
